module.exports = __webpack_public_path__ + "img/sh-ta.313be25.svg";